/**
 * THE PROGRAMMES A BRANCH MAY SUBSCRIBE TO, READ OFF `BranchRefObj`.
 *
 * SwaggerHub `Last-Modified` 27-09-2026 14:24 UTC. `RETAIL_RX` is Retail & Rx,
 * `SPONSORED` a sponsored programme, `GOVERNMENT` a government programme.
 * The field is parsed and not drawn: the MVP does not enrol a branch, and
 * the programme ticks stay off this screen (`AGENTS.md` ▸ Scope).
 */
import { z } from "zod/mini";
import type { components } from "./generated/pharmos-api";

export type BranchProgramme = NonNullable<components["schemas"]["BranchRefObj"]["programmes"]>[number];

export const BRANCH_PROGRAMMES = ["RETAIL_RX", "SPONSORED", "GOVERNMENT"] as const;

type InSync<Contract, Listed extends string> = [Contract] extends [Listed]
  ? [Listed] extends [Contract]
    ? true
    : never
  : never;

export const branchProgrammesInSync: InSync<BranchProgramme, (typeof BRANCH_PROGRAMMES)[number]> = true;

export const branchProgrammesSchema = z.optional(z.array(z.enum(BRANCH_PROGRAMMES)));
